import DD = require('./DD');
import DragSource = require('./DragSource');
import {InsertDestinationParams} from '../../../module/Modul';

/**
 * Base class for a drop zone
 */
    class DropZone extends DD {
        /**
         * @event ddover
         * @event ddout
         * @event dddrop
         *
         * @param {$.Event} original event
         * @param {Object} the original ui hash (usually coming from a jquery ui droppable/sortable)
         * @param {DropZone} this instance of DropZone
         */

        /**
         * The calculated zIndex of the element
         */
        protected zIndex: number = null;

        private targetEl: JQuery;

        constructor(element: JQuery|string|HTMLElement, targetEl: JQuery) {
            super(element);
            this.targetEl = targetEl;
        }

        getTargetEl() {
            return this.targetEl;
        }

        /**
         * Called when the drop zone is activated (usually when
         * the dragging starts). This method should enable the drop zone
         * so that it catches over/out/drop events
         */
        activate() {
            this.zIndex = this.element.diy_zIndex();
        }

        /**
         * The opposite action of activate
         * @abstract
         */
        deactivate() {
            // abstract
        }

        /**
         * Shows visual feedback that the zone accepts/rejects
         * the drag source that is currently over it
         * @abstract
         */
        showInvitation(canDrop: boolean) {
            // abstract
        }

        /**
         * Hides the visual feedback when no drag source is over
         * the drop zone
         * @abstract
         */
        hideInvitation() {
            // abstract
        }

        /**
         * Updates the visual feedback based on what's being dropped
         */
        updateView(dragSource: DragSource) {
            if (dragSource instanceof DragSource) {
                this.showInvitation(dragSource.canBeDropped(this) === true);
            } else {
                this.hideInvitation();
            }
        }

        onDragOver(e: Event, ui: {}) {
            this.trigger('ddover', e, [ui, this]);
        }

        onDragOut(e: Event, ui: {}) {
            this.trigger('ddout', e, [ui, this]);
        }

        onDrop(e: Event, ui: {}) {
            this.trigger('dddrop', e, [ui, this]);
        }

        getZIndex() {
            return this.zIndex;
        }

        getDestinationParams(): InsertDestinationParams {
            return {};
        }
    }

export = DropZone;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/common/js/dd/DropZone.ts
 **/